import React from 'react'
import ReactDOM from 'react-dom'
import RoomPageBase from './room-page-base'
import JumanjiSchedule from 'frontend/pages/rooms/jumanji-schedule'
import moment from 'lib/moment-timezone-custom'
import Glide, { Controls, Swipe, Autoplay, Images, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'
import clickToPlayWrap from 'lib/click-to-play-wrap'
import Reviews from 'frontend/pages/rooms/reviews'

export default class JumanjiPage extends RoomPageBase {
  static imagesSlider () {
    new Glide('.media .slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'carousel',
          focusAt: 'center',
          autoplay: 6000,
          hoverstop: true,
          perView: 1
        }
      )
    ).mount({ Swipe, Controls, Autoplay, Images })
  }

  static handleDOMReady () {
    super.handleDOMReady()
    this.imagesSlider()
    const { roomId, openedFrom, prebookingCodeOnly } = document.body.dataset

    ReactDOM.render(
      <JumanjiSchedule
        roomId={parseInt(roomId)}
        openedFrom={openedFrom && moment(openedFrom)}
        prebookingCodeOnly={prebookingCodeOnly !== undefined}
      />,
      document.getElementById('room_schedule_react')
    )

    clickToPlayWrap(document.querySelector('.media .slider .video'))
  }

  static handleStylesApplied () {
    Reviews.init()
  }
}

JumanjiPage.init()
